import { constants } from '../../../utilities'

export const text = {
    popup: {
        title: 'Besoin d’aide ou d’une information ?',
        subtitle: 'Nous sommes là pour vous !',
    },
    card: {
        helpCenterAndTutorials: {
            name: 'helpCenterAndTutorials',
            title: 'Mon centre d’aide et de tutoriels',
            description:
                'Découvrez nos courts tutoriels (vidéos et écrits) pour prendre en main vos outils en un temps record !',
            buttonName: 'Consulter les ressources',
            url: constants.HELP_CENTER_URL,
        },
        supportContact: {
            name: 'supportContact',
            title: 'Contacter le support technique',
            description:
                'Vous rencontrez une anomalie ? Vous avez besoin d’une assistance technique ? Contactez votre support utilisateur.',
        },
        exchangeViews: {
            name: 'exchangeViews',
            title: 'Echanger avec nous',
            description:
                'Besoin d’échanger avec le secrétariat médical ou tout autre service de TokTokDoc ? Nous sommes à votre écoute.',
        },
        newsFeed: {
            name: 'newsFeed',
            title: 'Fil de nouveautés de mes outils',
            description: 'Consultez le fil de nouveautés pour connaître les évolutions de vos deux outils TokTokDoc.',
            buttonName: 'Me tenir à jour',
            url: constants.NEWS_FEED_URL,
        },
    },
}
